import { Navigate } from 'react-router-dom';

// Support has moved into the app. Redirect to FAQ page which serves as
// the public-facing knowledge base and SEO content.
const Support = () => {
  return <Navigate to="/support/faq" replace />;
};

export default Support;
